/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Pricecurrent2Inputs */

const id_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ini:`)
};

const ms_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semasa:`)
};

const da_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende:`)
};

const de_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell:`)
};

const en_us2_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current:`)
};

const es_es2_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual:`)
};

const es_mx2_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual:`)
};

const fil_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyan:`)
};

const fr_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuel :`)
};

const it_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrente:`)
};

const hu_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuális:`)
};

const nl_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig:`)
};

const no_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nåværende:`)
};

const pl_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecna:`)
};

const pt_br2_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual:`)
};

const pt_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual:`)
};

const ro_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual:`)
};

const fi_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen:`)
};

const sv_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande:`)
};

const vi_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện tại:`)
};

const tr_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncel:`)
};

const cs_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální:`)
};

const bg_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текуща:`)
};

const ru_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая:`)
};

const uk_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поточна:`)
};

const ar_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالي:`)
};

const hi_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान:`)
};

const th_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัจจุบัน:`)
};

const ja_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在：`)
};

const zh_cn2_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前:`)
};

const zh_hant1_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前：`)
};

const ko_offerdetail_overview_pricecurrent2 = /** @type {(inputs: Offerdetail_Overview_Pricecurrent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재:`)
};

/**
* | output |
* | --- |
* | "Current:" |
*
* @param {Offerdetail_Overview_Pricecurrent2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_pricecurrent2 = /** @type {((inputs?: Offerdetail_Overview_Pricecurrent2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Pricecurrent2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "ms") return ms_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "da") return da_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "de") return de_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "fil") return fil_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "fr") return fr_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "it") return it_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "hu") return hu_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "nl") return nl_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "no") return no_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "pl") return pl_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "pt") return pt_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "ro") return ro_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "fi") return fi_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "sv") return sv_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "vi") return vi_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "tr") return tr_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "cs") return cs_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "bg") return bg_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "ru") return ru_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "uk") return uk_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "ar") return ar_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "hi") return hi_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "th") return th_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "ja") return ja_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_pricecurrent2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_pricecurrent2(inputs)
	return ko_offerdetail_overview_pricecurrent2(inputs)
});
export { offerdetail_overview_pricecurrent2 as "offerDetail.overview.priceCurrent" }